//@libs
import PropTypes from "prop-types";
//@mui-material
//import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
//import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
//@components
import IconButton from "./";

const MailIconButton = ({
  title = "Aprobar",
  icon = null,
  ...props
}) => {
  return (
    <IconButton
      sx={{
        "&:hover": {
          color: "#FF0000",
          transform: "scale(1.1)",
        },
      }}
      title={title}
      icon={icon || <CheckCircleOutlineIcon />}
      {...props}
    />
  );
};

MailIconButton.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.node,
};

export default MailIconButton;
